import kountSDK from "@kount/kount-web-client-sdk";

export const collectDeviceData = (kountSessionId: string) => {
  return new Promise((resolve, _reject) => {
    let failed = setTimeout(() => resolve(false), 5_000);
    kountSDK(
      {
        clientID: "743659474122018",
        environment: "PROD",
        isSinglePageApp: false,
        callbacks: {
          "collect-end": () => {
            clearTimeout(failed);
            resolve(true);
          },
        },
      },
      kountSessionId,
    );
  });
};